import SectionHeading from "./SectionHeading";

const steps = [
  {
    icon: "ri-list-ordered",
    title: "按排行榜挑",
    desc: "编辑评分从高到低排列，先扫一眼前三，基本不会踩雷，适合完全没头绪的时候。",
    hint: "看 #排行榜",
  },
  {
    icon: "ri-layout-masonry-line",
    title: "按主题挑",
    desc: "人性与欲望、家庭伦理、社会现实、悬疑罪案四个方向，决定你这两小时想被什么打动。",
    hint: "看 #主题合集",
  },
  {
    icon: "ri-search-line",
    title: "按关键词挑",
    desc: "记得片名、导演或某个关键词，直接在下方的搜索框里输入，结果只来自本页已有片单。",
    hint: "看 #排行榜筛选",
  },
  {
    icon: "ri-user-star-line",
    title: "按导演挑",
    desc: "认准一位作者的风格连续观看，是理解韩国电影最有效的方式，几位代表导演已整理在下方。",
    hint: "看 #导演风格",
  },
];

export default function QuickGuide() {
  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="快速挑片"
          title="四种方式，帮你从片荒走到下一部"
          desc="片单不怕长，怕的是不知道从哪看起。下面这四种挑选路径覆盖了绝大多数观影场景，挑一条顺手的开始就好。"
        />

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((step) => (
            <article
              key={step.title}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100/60 p-5 transition-colors hover:border-primary-300"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className={`${step.icon} text-xl`}></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                {step.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                {step.desc}
              </p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-label text-accent-700">
                <i className="ri-arrow-right-line"></i>
                {step.hint}
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}